










































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { CrudForm, KeywordsInput, RegularFilterSelector, UiTextbox } from '../../components';

import { CrudFormMixin } from '../../mixins';

import { Dictionary, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'redirections-form',
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    KeywordsInput,
    RegularFilterSelector,
    UiTextbox
  },
  computed: {
    keywordsHelpText: function (): string {
      return this.item.matchAll ? this.messages.fields.placeholders.keywords.disabled : this.messages.fields.placeholders.keywords.active;
    },
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config.mandatory = true;
      return filters;
    },
    valid: function (): boolean {
      if (!this.item.filters.lang.length) {
        return false;
      }
      if (!this.item.keywords.length) {
        return false;
      }
      if (!this.item.url) {
        return false;
      }
      return true;
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.REDIRECTION,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.redirections.update),
      item: {
        enabled: true,
        keywords: [],
        url: '',
        filters: {
          lang: []
        },
        schedule: {
          activationDate: null,
          deactivationDate: null
        }
      },
      messages: this.$epb.messages.tools.redirections
    };
  }
};

